import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from './../../shared-components/System';
import { CodeLegend, Doctors, HealthVisitLog, Immunizations, Insurance, Medications, Screening } from './health.model';

@Injectable({
  providedIn: 'root'
})
export class HealthService {

  constructor(
    private http: HttpClient
  ) { }

  // Get Immunizations
  getImmunizations(studentId: number, yearId: number): Observable<Immunizations[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&yearId=' + yearId;
    return this.http.get<Immunizations[]>(System.apiURL.Student + 'GetImmunizations' + queryString);
  }

  // Get Medication
  getMedication(studentId: number, yearId: number): Observable<Medications[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&yearId=' + yearId;
    return this.http.get<Medications[]>(System.apiURL.Student + 'GetMedication' + queryString);
  }

  // Get HealthVisitLog
  getHealthVisitLog(studentId: number, yearId: number, siteYearId: number): Observable<HealthVisitLog[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&yearId=' + yearId + '&siteYearId=' + siteYearId;
    return this.http.get<HealthVisitLog[]>(System.apiURL.Student + 'GetHealthVisitLog' + queryString);
  }

  // Get Doctors
  getDoctors(studentId: number, yearId: number): Observable<Doctors[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&yearId=' + yearId;
    return this.http.get<Doctors[]>(System.apiURL.Student + 'getDoctors' + queryString);
  }

  // Get Insurance
  getInsurance(studentId: number, yearId: number): Observable<Insurance[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&yearId=' + yearId;
    return this.http.get<Insurance[]>(System.apiURL.Student + 'GetInsurance' + queryString);
  }

  // Get Screenings
  getScreenings(studentId: number): Observable<Screening[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId;
    return this.http.get<Screening[]>(System.apiURL.Student + 'GetScreenings' + queryString);
  }

  // Get ScreeningCodeLegend
  getScreeningCodeLegend(studentId: number): Observable<CodeLegend[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId;
    return this.http.get<CodeLegend[]>(System.apiURL.Student + 'GetScreeningCodeLegend' + queryString);
  }
}